export default "__VITE_ASSET__B_QWGkQ7__"